import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

const PaymentAlertModal = ({ paymentAlert, setPaymentAlert }) => {
  const { t } = useTranslation();
  return (
    <>
      <Modal
        title={<p>{t('unpaid.modal.title')}</p>}
        centered
        open={paymentAlert}
        onCancel={() => {
          setPaymentAlert(false);
        }}
        onOk={() => {
          setPaymentAlert(false);
        }}
        width={600}
      >
        <div style={{ textAlign: 'center', fontWeight: 700 }}>
          {t('unpaid.modal.warning_status_modal')}
        </div>

        <div
          style={{
            marginBottom: 20,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        />
      </Modal>
    </>
  );
};
PaymentAlertModal.propTypes = {
  setPaymentAlert: PropTypes.func.isRequired,
  paymentAlert: PropTypes.bool.isRequired
};
export default PaymentAlertModal;
